import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
    margin: 0;
    outline: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
  }

  body {
    background-color: #F9F9F9;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font-family: 'Montserrat', sans-serif;
  }

  button {
    cursor: pointer;
  }

  img, svg {
    vertical-align: middle;
  }

  ul {
    list-style: none;
  }
`;